<template>
  <div class="index" id="j-tracker" :class="{overflow: searchPop}">
		<ddheader v-if="!$sys.browser.inset" :title="json.name" :fixed="1" />

    <!--搜索弹窗-->
    <div class="ddsearch" v-if="searchPop">
      <ddsearch
        :word="checkWord"
        :searchUrl="searchUrl"
        @closeSearchPopSend="closeSearchPopGet"></ddsearch>
    </div>
    <spe-live></spe-live>

    <!-- 上报 -->
    <speReport></speReport>

		<div class="com">
      <div v-for="(v, k) in json.floors" :key="k" :data-index="k" :id="'id' + v.floorId" :data-compIden="v.compIden" :data-minh="v.height || 0">
        <template v-if="v.compIden === 'spe-firstorder-secondorder'">
          <spe-firstorder-secondorder :json="v" @refreshComData="getSpecialPageData(k)" ref="speFirstorderSecondorder" />
        </template>
        <template v-if="v.compIden === 'spe-old-more-coupon'">
          <spe-old-more-coupon :json="v" ref="speOldMoreCoupon" />
        </template>
        <template v-if="v.compIden === 'spe-small-horn'">
					<spe-small-horn :json="v" ref="speSmallHorn"/>
				</template>
        <template v-if="v.compIden === 'spe-bang-threeinone'">
          <spe-bang-threeinone :json="v" ref="speBangThreeinone"/>
        </template>
        <template v-if="v.compIden === 'spe-book-list'">
					<spe-book-list :json="v" ref="speBookList"/>
				</template>
        <template v-if="v.compIden === 'spe-static-code'">
					<spe-static-code :json="v" ref="speStaticCode"/>
				</template>
				<template v-if="v.compIden === 'spe-general-goods' && v.compStyle == 3">
					<spe-general-goods-one :json="v" :pagebgcolor="json.bgColor" ref="speGeneralGoods"/>
				</template>
				<template v-if="v.compIden === 'spe-general-goods' &&  v.compStyle != 3">
					<spe-general-goods :json="v" :pagebgcolor="json.bgColor" ref="speGeneralGoods"/>
				</template>
				<template v-if="v.compIden === 'spe-general-goods-tabs'">
					<spe-general-goods-tabs :json="v" ref="speGeneralGoodsTabs" @changeTab="listenChangeTab"/>
				</template>
        <template v-if="v.compIden === 'spe-recommend-goods'">
          <spe-recommend-goods :json="v"  ref="speRecommendGoods" v-if="v.isShowFloor"></spe-recommend-goods>
        </template>
				<template v-if="v.compIden === 'spe-text'">
					<spe-txt-explain :json="v" ></spe-txt-explain>
				</template>
				<template v-if="v.compIden === 'spe-live'">
					<spe-live :json="v" ></spe-live>
				</template>
				<template v-if="v.compIden === 'spe-coupon'">
					<spe-coupons :json="v"></spe-coupons>
				</template>
				<template v-if="v.compIden === 'spe-discount-code' || v.compIden === 'spe-couponcode-combine'">
					<spe-discount-code :json="v"></spe-discount-code>
				</template>
				<template v-if="v.compIden === 'spe-lift'">
					<spe-lift :json="v" :pagebgcolor="json.bgColor"></spe-lift>
				</template>
				<template v-if="v.compIden === 'spe-picture-list'">
					<spe-picture-list :json="v"></spe-picture-list>
				</template>
				<template v-if="v.compIden === 'spe-picture-carousel'">
					<spe-picture-carousel :json="v" :rule-info="otherInfo"></spe-picture-carousel>
				</template>
				<template v-if="v.compIden === 'spe-split'">
					<spe-split :json="v" :pagebgcolor="json.bgColor"></spe-split>
				</template>
				<template v-if="v.compIden === 'spe-bottom-tab'">
					<spe-bottom-tab :json="v" :pagebgcolor="json.bgColor" :isMina="isMina" :isIos="isIos"></spe-bottom-tab>
				</template>
				<template v-if="v.compIden === 'spe-picture-menu'">
					<spe-picture-menu :json="v"></spe-picture-menu>
				</template>
				<template v-if="v.compIden === 'spe-search'">
					<spe-search
            :json="v"
            :pagebgcolor="json.bgColor"
            @openSearchPopSend="openSearchPopGet"></spe-search>
				</template>

			<template v-if="v.compIden === 'spe-picture-complex'">
                <spe-picture-complex :json="v"></spe-picture-complex>
			</template>
            <template v-if="v.compIden === 'spe-slide-goods'">
                <spe-slide-goods :json="v"></spe-slide-goods>
            </template>
            <template v-if="v.compIden === 'spe-count-down'">
                <spe-count-down :json="v" @setCountDown="setCountDown" :posInfo="posInfo" :isMina="isMina" :isIos="isIos"></spe-count-down>
            </template>
            <template v-if="v.compIden === 'spe-suspension-icon'">
                <spe-suspension-icon :json="v" :posInfo="posInfo" :isMina="isMina" :isIos="isIos"></spe-suspension-icon>
            </template>
        <template v-if="v.compIden === 'spe-roll-picture'">
          <spe-roll-picture :json="v" :floor-index="k"></spe-roll-picture>
        </template>
        <template v-if="v.compIden === 'spe-picture-hotspot'">
          <spe-picture-hotspot :json="v" :floor-index="k"></spe-picture-hotspot>
        </template>
			</div>
		</div>
		<div :style="{height: bottomHeight + 'rem'}"></div>

		<div class="totop" @click="handleScrollTop" v-show="totop_show" :style="{bottom : toTopBottom + 'rem'}">
			<span class="iconfont">&#xe60b;</span>
		</div>
	</div>
</template>

<script>
// 引入组件
import ddheader from "@/components/ddheader";
import ddsearch from "@/components/ddsearch";
import speGeneralGoods from "@/h5Components/spe-general-goods";
import speGeneralGoodsOne from "@/h5Components/spe-general-goods-one";
import speRecommendGoods from "@/h5Components/spe-recommend-goods";
import speGeneralGoodsTabs from "@/h5Components/spe-general-goods-tabs";
import speLift from "@/h5Components/spe-lift";
import spePictureList from "@/h5Components/spe-picture-list";
import spePictureCarousel from "@/h5Components/spe-picture-carousel";
import speSplit from "@/h5Components/spe-split";
import speBottomTab from "@/h5Components/spe-bottom-tab";
import spePictureMenu from "@/h5Components/spe-picture-menu";
import speSearch from "@/h5Components/spe-search";
import speCoupons from "@/h5Components/spe-coupons";
import speDiscountCode from "@/h5Components/spe-discount-code";
import speTxtExplain from "@/h5Components/spe-txt-explain";
import speReport from "@/h5Components/spe-report";
import speBookList from "@/h5Components/spe-book-list";
import speStaticCode from "@/h5Components/spe-static-code";
import speLive from "@/h5Components/spe-live";
import speSuspensionIcon from '@/h5Components/spe-suspension-icon'
import spePictureComplex from '@/h5Components/spe-picture-complex'
import speSlideGoods from '@/h5Components/spe-slide-goods'
import speCountDown from '@/h5Components/spe-count-down'
import speRollPicture from '@/h5Components/spe-roll-picture'
import spePictureHotspot from '@/h5Components/spe-picture-hotspot'
import {writeADScript} from '../assets/js/commonH5.js' // 推荐广告埋点上报
export default {
	name: "index",
	metaInfo() {
		return {
			title: this.json.name || ""
		};
	},
	components: {
		ddheader,
    ddsearch,
		speGeneralGoods,
    speGeneralGoodsOne,
		speGeneralGoodsTabs,
    speRecommendGoods,
		speLift,
		spePictureList,
		spePictureCarousel,
		speSplit,
		speBottomTab,
		spePictureMenu,
		speSearch,
    speCoupons,
    speDiscountCode,
    speTxtExplain,
    speReport,
    speBookList,
    speStaticCode,
    speLive,
    speSuspensionIcon,
    spePictureComplex,
    speSlideGoods,
    speCountDown,
    speRollPicture,
    spePictureHotspot,
    speSmallHorn:()=>import('@/h5Components/spe-small-horn/index.vue'),
    speBangThreeinone:()=>import('@/h5Components/spe-bang-threeinone/index.vue'),
    speFirstorderSecondorder:()=>import('@/h5Components/spe-firstorder-secondorder/index.vue'),
    speOldMoreCoupon:()=>import('@/h5Components/spe-old-more-coupon/index.vue')
	},
	data() {
		return {
            json: {}, //页面框架
            bgColor: "",
            shareData: {},
            is_bottom_tab: false,
            totop_show:false,
            searchPop:false,
            search:null,
            checkWord:'',
            searchUrl:'',
            scrollToTId:'',
            productNum:10,// 几个品请求一次
            isFirstGoodsFloor:true,
            person_on:1, //推荐品入参是否开启个性化 默认1
            global_province_id:111,  //推荐品入参所选城市 默认111
            pt:'',
            posInfo: {
                countDown: false,
                toTop: false,
                bottomTab: false
            },
            isAndroid: false,
            isIos: false,
            isMina: false, // 小程序
            otherInfo: {
              name: '',
              jumpLink: '',
            }, // 新人专区落地页规则信息
		};
	},
    computed: {
        toTopBottom() {
            let {countDown, toTop, bottomTab} = this.posInfo
            const data = this.isIos && this.isMina ? 0.68 : 0
            if( bottomTab && countDown && toTop ) {
                return 2.00 + data
            } else if(bottomTab && !countDown && toTop) {
                return 1.20 + data
            } else if (!bottomTab && countDown && toTop) {
                return 1.00 + data
            } else {
                return 1.00 + data
            }
        },
        bottomHeight() {
            let {countDown, bottomTab} = this.posInfo
            const data = this.isIos && this.isMina ? 0.68 : 0
            if( bottomTab && countDown ) {
                return  1.70 + data
            } else if(bottomTab && !countDown) {
                return 1.00 + data
            } else if (!bottomTab && countDown) {
                return  0.70 + data
            } else {
                return  0.00 + data
            }
        }
    },
  provide () {
    return {
      pt: this.returnPt,
      getProductsInfoData: this.getProductsInfoData
    }
  },
  created() {
    const {global_province_id,person_on,pt} = this.$route.query
    this.pt = pt || ''
    this.global_province_id = global_province_id || 111
    this.person_on = (person_on === 0 ||!!person_on) ? person_on : 1
  },
  mounted() {
		document.querySelector("body").setAttribute("ddt-page", this.$route.query.pt);
		this.getSpecialPageInfo();
		// this.getShareData()
        const userClient = this.$route.query.user_client || ''
        this.isMina = userClient == 'mina'
        let ua = navigator.userAgent
        this.isIos = ua.match(/(iPhone\sOS)\s([\d_]+)/)
        this.isAndroid = ua.match(/(Android);?[\s\/]+([\d.]+)?/)
	},
	methods: {
    setCountDown(value = false) {
      this.posInfo.countDown = value
    },
    // 返回专题页名称
    returnPt () {
      return this.pt
    },
    async toLogin () {
      let url_ = window.location.href
      const login_url = process.env.VUE_APP_MDD_LOGIN_URL + window.location.href;
      const userClient = this.$route.query.user_client || ''
      if (userClient == 'iphone' || userClient == 'android') {
        appBridge.callLogin({
          response: "after_login",
        })
        window.after_login = res => {
          window.location.href = url_
        }
      } else if(userClient == 'mina'){
        let loginUrl = `/pages/login/login?url=${encodeURIComponent(`/pages/cms/cms?page_id=${this.$route.query.pt}`)}`
        await this.$onLaunched
        console.log('wxxxx-SDK-Obj',window.wx)
        wx.miniProgram.redirectTo({url: loginUrl})
      } else if (userClient == "huawei") {
        system.go("/login");
      } else { //触屏
        window.location.href = login_url;
      }
    },
		/**
		 * 获取页面框架
		 */
		async getSpecialPageInfo() {
      this.$axios.post('/mapi/get_mydangdang_info', { params: { test: 1 }, data: { alert: true } })
      let { data, ...res } = await this.$axios.get("/jmapi/cms/pageInfo", { params: { pt: this.$route.query.pt } });
      // 增加“96”未登录的处理逻辑
      if (res.errorCode == 96) {
        this.toLogin();
        return
      } else {
        if (!data) {
          console.error('框架数据错误', res)
          return
        }
      }
      // 加上占位标志
      if (data.floors && data.floors.length) {
        data.floors.forEach(v => {
          if (v) {
            v.init = true
          }
        })
      }
			this.json = data || {};
      this.otherInfo = data.otherInfo || {}
      document.querySelector("body").style.backgroundColor = data.bgColor || "";
			//框架页加载完 就比较楼层位置
			this.$nextTick(() => {
        this.handleScroll();

				//查找spe-bottom-tab和spe-count-down楼层，立即加载数据
				if (data && data.floors) {
					let bottomFloorIndex = data.floors.findIndex(el => {
						return el.compIden == "spe-bottom-tab";
					});
					if (bottomFloorIndex > -1) {
						this.is_bottom_tab = true;
            this.posInfo.bottomTab = true
						this.$nextTick(() => {
							this.getSpecialPageData(bottomFloorIndex);
						});
					}
					let countFloorIndex = data.floors.findIndex(el => {
						return el.compIden == "spe-count-down";
					});
					if (countFloorIndex > -1) {
						this.$nextTick(() => {
							this.getSpecialPageData(countFloorIndex);
						});
					}
				}
        this.$nextTick(() => {
          window.addEventListener("scroll", this.throttle);
        })
			});
		},

    // 切换tab 请求第一页数据
    listenChangeTab(){
      setTimeout(() => {
        this.handleScroll()
      }, 100);
    },

    // 节流函数
   throttle(){
      clearTimeout(this.scrollToTId);
      this.scrollToTId = setTimeout(()=>{
        this.handleScroll()
      },100);
    },

    openSearchPopGet(msg){
      this.checkWord = msg.word
      this.searchUrl = msg.searchUrl
      this.searchPop = !this.searchPop
      window.pageYOffset = document.documentElement.scrollTop = document.body.scrollTop = 0 // 重置到顶部
    },

    closeSearchPopGet(){
      this.searchPop = !this.searchPop
    },

		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			let wheight=window.screen.height;//页面高度

      if( scrollTop >= wheight ){
        this.totop_show=true
        this.posInfo.toTop = true
      }else{
        this.totop_show=false
        this.posInfo.toTop = false
      }

      let pageScrollTop = scrollTop + wheight; //滚动高度 + 页面高度


      let divs = document.querySelectorAll(".com>div");
      //遍历所有楼层  楼层高度和滚动条高度做比较
      for (let div of divs) {
        let loaded = div.getAttribute("data-loaded");
        if (!loaded && pageScrollTop >= div.offsetTop) {
          this.getSpecialPageData(div.getAttribute("data-index"));
        }
      }
      this.loadGoodTabs(pageScrollTop)
      this.loadGoods(pageScrollTop)
		},

    /***
     *  GOODS 懒加载
     */
    loadGoods(scrollTop){
      // 没有该楼层返回
      if(!this.$refs.speGeneralGoods || this.$refs.speGeneralGoods.length <= 0) return;

      // 定位在哪个楼层
      this.$refs.speGeneralGoods.forEach((v,k)=>{
        const goodsHeight = v.$el.offsetHeight, goodsTop = v.$el.offsetTop, floorId = v.json.floorId;
        const windowH = window.innerHeight


        // 楼层底部需要判断是否超过屏幕显示区域
        if(goodsTop <= scrollTop &&  scrollTop < goodsHeight + goodsTop + windowH){
          try {
            if(v.$children && v.$children.length > 0 && v.$children[0].children && v.$children[0].children.length > 0 ){

              // 定位在哪个品
              v.$children[0].children.forEach((val,key)=>{
                if((key) % this.productNum === 0){
                  let productHeight = val.elm.offsetHeight,productTop = val.elm.offsetTop;
                  const compStyleNum = val.elm.dataset.comptype == 3 ? 1 : 2
                  // 两层楼高度区间
                  if( (productTop - 40) <= scrollTop  && scrollTop < (productHeight * (Math.floor(this.productNum / compStyleNum)) + productTop - 10) ){
                    // 已经加载过不请求
                    if(val.data.attrs.el.isProduct) return;
                    let pageProductId = val.data.attrs.el.productId,productIdArr = [],sortFlag = -1;

                    // 组装pids
                    v.json.data.pids.forEach((id)=>{
                      if(id == pageProductId){
                        productIdArr.push(id)
                        sortFlag = 0
                        return
                      }
                      if(sortFlag >= 0 && sortFlag < this.productNum - 1){
                        sortFlag++
                        productIdArr.push(id)
                      }
                    })

                    // 获取对应品数据
                    
                    this.getProductsInfoData(floorId,"",productIdArr.join(',')).then( (result)=>{
                      let jsonProducts = v.json.data.products
                      jsonProducts.forEach((item,index)=>{
                        result.products.forEach((product)=>{
                          item.productId == product.oldPid ?  jsonProducts[index] = product : ''
                        })
                      })
                      this.$set( v.json.data,'products',[])
                      this.$set( v.json.data,'products',jsonProducts)

                    })
                  }
                }
              })
            }
          }catch (e) {
            console.error(e)
          }
        }
      })
    },

    /***
     *  GOODSTABS 懒加载
     */
    loadGoodTabs(scrollTop){
      // // 定位在哪个楼层
      if(!this.$refs.speGeneralGoodsTabs ||  this.$refs.speGeneralGoodsTabs.length <= 0) return;
      try {
        this.$refs.speGeneralGoodsTabs.forEach((v,k)=>{
        const goodsHeight = v.$el.offsetHeight
        const goodsTop = v.$el.offsetTop
        const windowH = window.innerHeight

        // 楼层底部需要判断是否超过屏幕显示区域
        if( goodsTop <= scrollTop &&  scrollTop <= goodsHeight + goodsTop + windowH){
            let currentTab = v.current, currentTabId = 1, floorId = v.json.floorId;
            if(v.json.data && v.json.data.tabsData &&  v.json.data.tabsData.length > 0) {
              currentTabId= v.json.data.tabsData[currentTab].id || 1;
            }
            if(v.$children && v.$children.length > 0 &&  v.$children[0].children &&  v.$children[0].children.length > 0 && v.$children[0].children[currentTab] && v.$children[0].children[currentTab].children){
              // 定位在哪个品
              v.$children[0].children[currentTab].children.forEach((val,key)=>{
                if((key) % this.productNum === 0){
                  let productHeight = val.elm.offsetHeight,productTop = val.elm.offsetTop;

                  // 两层楼高度区间
                  if( (productTop - 40) <= scrollTop  && scrollTop < (productHeight * (Math.floor(this.productNum / 2)) + productTop - 10) ){

                    // 已经加载过不请求
                    if(val.data.attrs.el.isProduct) return;
                    let pageProductId = val.data.attrs.el.productId,productIdArr = [],sortFlag = -1;

                    // 组装pids
                    v.json.data.tabsData[currentTab].pids.forEach((id)=>{
                      if(id == pageProductId){
                        productIdArr.push(id)
                        sortFlag = 0
                        return
                      }
                      if(sortFlag >= 0 && sortFlag < this.productNum - 1){
                        sortFlag++
                        productIdArr.push(id)
                      }
                    })

                    // 获取对应品数据
                    this.getProductsInfoData(floorId,currentTabId,productIdArr.join(',')).then( (result)=>{
                      let jsonProducts = v.json.data.tabsData[currentTab].products
                      jsonProducts.forEach((item,index)=>{
                        if(!result.products || result.products.length == 0) return;
                        result.products.forEach((product)=>{
                          item.productId == product.oldPid ? jsonProducts[index] = product : ''
                        })
                      })

                      // 页面塞数据
                      let tabsDatas = v.json.data.tabsData
                      tabsDatas[currentTab].products = jsonProducts
                      this.$set( v.json.data,'tabsData',[])
                      this.$set( v.json.data,'tabsData',tabsDatas)
                    })
                  }
                }
              })
            }else{
              return
            }
        }
      })
      }catch (e) {
        console.error(e)
      }
    },
		/**
		 * 获取楼层数据
		 */
		async getSpecialPageData(index) {
			let floor = this.json.floors[index];

			if (!floor) return false;

			let divs = document.querySelectorAll(".com>div");
			divs[index].setAttribute("data-loaded", true)

      try {
        let { errorCode, data } = await this.$axios.get("/jmapi/cms/pageData", { params: { pt: this.$route.query.pt, floorIds: floor.floorId } });

        // 根据品id 填占位
        if(data.floors[0] && data.floors[0].compIden) {
          // // 带tab数据 请求第一页
          if(data.floors[0].compIden === "spe-general-goods-tabs"){
            data.floors[0].data.tabsData = await this.setGoodsTab(floor.floorId,data,index)
          }

          // 不带tab数据
          if(data.floors[0].compIden === "spe-general-goods"){
              data.floors[0].data = await this.setGoods(floor.floorId,data,index)
          }

          // 推荐品楼层
          if(data.floors[0].compIden === "spe-recommend-goods"){
            await this.getRecommendProductIds(floor.floorId,data,index)
          }

          // 滑动商品品楼层
          if(data.floors[0].compIden === "spe-slide-goods"){
            data.floors[0].data.products= await this.getSlideGoods(floor.floorId, data,index)
          }
        }

        if (errorCode == 0 && data.floors[0]) {
          if(data.floors[0].data.commonStyle){
            data.floors[0].data.commonStyle.bgColor = this.json.bgColor
          }
          if (divs[index].getAttribute('data-minh')) {
            data.floors[0].data.height = divs[index].getAttribute('data-minh') || 0
          }
          this.$set(this.json.floors[index], "data", data.floors[0].data || data.floors[0].compData);
          this.$set(this.json.floors[index], "init", false) // 隐藏占位区域，显示数据
        }
      } catch (e) {
        console.error('jmapi/pageData处理逻辑出错', e)
      }
		},

    // 展位坑
    placeObj(v) {
		  return {
        authorName: ".",
        desc: ".",
        imgUrl: "http://img60.ddimg.cn/upload_img/00848/hjwh5/placeBg-1610949592.png",
        labels: [],
        link: "",
        productId: v,
        salePrice: "",
        showCart: 0,
        title: ".",
        isProduct: false
      }
    },

    getSlideGoods(floorId, data, index) {
      let floor = this.json.floors[index],pageNum = 20 ,arrPlaceProduct = [];
      let tableData = data.floors[0].data;
      let firstPagePids = []
      if (!tableData.products && tableData.tabsData && tableData.tabsData.length && tableData.tabsData[0].pids && tableData.tabsData[0].pids.length) {
        firstPagePids = tableData.tabsData[0].pids.slice(0,pageNum)
        // 遍历id 塞占坑空数据
        tableData.tabsData[0].pids.map((v,k) => {
          arrPlaceProduct.push(this.placeObj(v))
        })
        tableData.products = arrPlaceProduct
        data.floors[0].data = tableData
        this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        const currentTab = tableData.tabsData && tableData.tabsData.length ? tableData.tabsData[0].id : ''
        // 设置首页品
        this.getProductsInfoData(floorId, currentTab, firstPagePids.join(',')).then(res=>{
          arrPlaceProduct = res.products.concat(arrPlaceProduct.slice(pageNum))
          tableData.products = arrPlaceProduct
          data.floors[0].data = tableData
          this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        })
      } else if (!tableData.products && tableData.pids && tableData.pids.length > 0) {
        firstPagePids = tableData.pids.slice(0,pageNum)
        // 遍历id 塞占坑空数据
        tableData.pids.map((v,k) => {
          arrPlaceProduct.push(this.placeObj(v))
        })
        tableData.products = arrPlaceProduct
        data.floors[0].data = tableData
        this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        // 设置首页品
        this.getProductsInfoData(floorId, '', firstPagePids.join(',')).then(res=>{
          arrPlaceProduct = res.products.concat(arrPlaceProduct.slice(pageNum))
          tableData.products = arrPlaceProduct
          data.floors[0].data = tableData
          this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        })
      }
      
      return tableData
    },

    // 设置空数据 spe-general-goods-tabs
    setGoodsTab(floorId,data,index){
      let floor = this.json.floors[index],pageNum = this.productNum;
      let tableData = data.floors[0].data.tabsData;
      tableData.forEach((tabList,tabIndex)=>{
        let arrPlaceProduct = []
        // 遍历id 塞占坑空数据
        if (!tabList.products && tabList.pids && tabList.pids.length > 0) {
          let firstPagePids = tabList.pids.slice(0,pageNum)
          tabList.pids.map((v,k) => {
            arrPlaceProduct.push(this.placeObj(v))
          })
          tabList.products = arrPlaceProduct
          data.floors[0].data.tabsData = tabList
          this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
          // 设置首页品
          this.getProductsInfoData(floorId,tabList.id,firstPagePids.join(',')).then(res=>{
            arrPlaceProduct = res.products.concat(arrPlaceProduct.slice(pageNum))
            tableData[tabIndex].products = arrPlaceProduct
            data.floors[0].data.tabsData = tableData
            // this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
          })
        }
      })
      return tableData
    },

    // 设置空数据 spe-general-goods
    setGoods(floorId,data,index){
      let floor = this.json.floors[index],pageNum = this.productNum,arrPlaceProduct = [];
      let tableData = data.floors[0].data;
      if (!tableData.products && tableData.pids && tableData.pids.length > 0) {
        let firstPagePids = tableData.pids.slice(0,pageNum)
        // 遍历id 塞占坑空数据
        tableData.pids.map((v,k) => {
          arrPlaceProduct.push(this.placeObj(v))
        })
        tableData.products = arrPlaceProduct
        data.floors[0].data = tableData
        this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        // 设置首页品
        this.getProductsInfoData(floorId,'',firstPagePids.join(',')).then(res=>{
          arrPlaceProduct = res.products.concat(arrPlaceProduct.slice(pageNum))
          tableData.products = arrPlaceProduct
          data.floors[0].data = tableData
          this.$set(floor, "data", data.floors[0].data || data.floors[0].compData);
        })
      }
      return tableData
    },
    /**
     * 获取推荐品IDS
     */
    async getRecommendProductIds(floorId, floorData, index) {
      let paths = floorData.floors[0].data.paths ? floorData.floors[0].data.paths: 0
      let promotionIds = floorData.floors[0].data.promotionIds ? floorData.floors[0].data.promotionIds : 0
      if(paths && promotionIds){
        const params = {
          pt: this.pt,
          floorId: floorId,
          global_province_id: this.global_province_id,
          person_on: this.person_on,
          source: 'mb_reco_promo_tab',//mb_reco_catecmpt_home
          promotionIds: promotionIds,
          paths: paths
        }
        let { errorCode, data } =  await this.$axios.get("/jmapi/cms/recommend/productsInfo", { params })
        if(errorCode == 0 && data.productList && data.productList.length > 0) {
          data.productList.map((v)=>{ 
            v.isProduct = "on"
            v.itemTraceReco = v.itemTrace.replace("model_name","module_name").replace("requestid","request_id").replace("reco_pos","position")
          })
          let pageTrace = data.pageTrace
          pageTrace = pageTrace.replace("model_name","module_name").replace("requestid","request_id")
          floorData.floors[0].data.pageTrace = pageTrace
          floorData.floors[0].data.products = data.productList
          let floor = this.json.floors[index]
          this.$set(floor, "data", floorData.floors[0].data || floorData.floors[0].compData);
          this.$set(floor, "isShowFloor", true);
          this.collectRealdata()
        } else {
          let floor = this.json.floors[index]
          this.$set(floor, "isShowFloor", false);
        }
      }
    },
    /**
     * 搜索曝光 点击
    */
   collectRealdata(){
     let scriptSrc = process.env.VUE_APP_RECOSYS_RECOMMEND_JS_URL
      // setTimeout(() => {
      writeADScript({
        src: scriptSrc, 
        scriptId: "j_recosysScript",
        id: "mallRecommendGoods"
      })
      // }, 3000);
   },
    /**
     * 获取品数据
     */
    async getProductsInfoData(floorId=0, currentTab='',pids="") {
      const params = {
        pt: this.$route.query.pt,
        floorId: floorId,
        tabId:currentTab,
        pids:pids
      }
      let { errorCode, data } =  await this.$axios.get("/jmapi/cms/productsInfo", { params })
      // 请求成功数据 isProduct == true
      if(errorCode == 0 &&  data.products &&  data.products.length > 0){
        data.products.map((v)=>{ v.isProduct = "on" })
        return data
      }else{
        return { products: [] }
      }
    },
		// 获取页面分享数据
		async getShareData() {
			let { errorCode, data } = await this.$axios.get("/jmapi/cms/pageShareInfo", { params: { pt: this.$route.query.pt } });
			if (errorCode === 0) {
				this.shareData = data;
			} else {
				console.log("获取分享数据接口失败");
			}
		},

		handleScrollTop() {
			window.scrollTo(0, 0);
		}
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	}
};
</script>
<style lang="less" scoped>
.index {
	min-height: 100%;
  &.overflow {
    height: 100vh;
    overflow: hidden;
  }
	.h100 {
		height: 100px;
	}
	.totop {
		position: fixed;
		right: 20px;
		width: 80px;
		height: 80px;
		border-radius: 100%;
		background: rgba(0, 0, 0, 0.6);
		text-align: center;
		line-height: 80px;
		color: #fff;
		font-size: 40px;
		z-index:99;
	}
  .ddsearch{
    width: 100%;
    height: 100%;
    min-width: 100vw;
    min-height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #FFF;
    z-index: 999;
  }
}
</style>
